export default {
  onboardingHeader: {
    logIn: "Log in",
    logout: "Log out",
  },
  splitLayout: {
    backButton: "Back",
  },
  navigation: {
    header: {
      controlPanel: "Dataships Control Panel",
      helpDropdown: {
        knowledgeCenter: "Knowledge Center",
        contactSupport: "Contact Support",
      },
      profileDropdown: {
        companyProfile: "Company Profile",
        billing: "Billing",
        userManagement: "User Management",
      },
    },
    definition: {
      email: {
        title: "Email",
        sidebar: {
          dashboard: "Dashboard",
          usage: "Usage Dashboard",
          marketableAudiences: "Marketable Audiences",
          auditLogs: "Audit Logs",
          complianceReports: "Compliance Reports",
          emailMarketingChecklist: "Email Marketing Checklist",
        },
      },
      sms: {
        title: "SMS",
        sidebar: {
          healthCheck: "Health Check",
          healthCheckHistory: "Health Check History",
          marketableAudiences: "Marketable Audiences",
          auditLogs: "Audit Logs",
          complianceReports: "Compliance Reports",
          feature: "New Feature: SMS",
        },
      },
      comply: {
        title: "Comply",
        privacyCenter: "Privacy Center",
        policies: "Policies",
      },
      settings: {
        title: "Settings",
        sidebar: {
          widgetSettings: "Widget Settings",
          integrationSettings: "Integration Settings",
          companyProfile: "Company Profile",
          billing: "Billing",
          userManagement: "User Management",
        },
      },
      integrations: {
        title: "Integrations",
        sidebar: {
          matSettings: "MAT Settings",
          shopSettings: "Shop Settings",
        },
      },
      profile: {
        title: "Profile",
        sidebar: {
          company: "Company Profile",
          billing: "Billing",
          userManagement: "User Management",
        },
      },
      help: {
        title: "Help",
        sidebar: {
          knowledgeBase: "Knowledge Base",
          contactSupport: "Contact Support",
        },
      },
    },
  },
} as const;
